/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processaArquivo, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {MovimentoCaixa} from '../../models/movimento_caixa'
import {BaseDescSCH, getBaseSCH} from "../../search/BaseSCH";
import {MovimentoCaixaSCH} from "../../search/MovimentoCaixaSCH";

const url = '/movimento_caixa'

const state = {
  all: [],
  allList: [],
  movimento_caixa: new MovimentoCaixa(),
  filtro: new Filtro()
}

const getters = {
  listaAllMovimentoCaixas: (state) => {
    return state.allList
  },

  listaMovimentoCaixas: (state) => {
    return state.all
  },
  pegaMovimentoCaixa: (state) => {
    return state.movimento_caixa
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['descr_compl', 'caixas.descr', 'eventos_caixa.descr'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {id, onSucesso,onErro}) {
    try {
      var filtro = getBaseSCH('movimento_caixa_id', id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_MOVIMENTO_CAIXA', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', MovimentoCaixaSCH(perPage))
  },

  async setAllListMovimentoCaixas({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
    },
  async setAllMovimentoCaixas({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_MOVIMENTO_CAIXAS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },

  async printMovCaixa({commit}, {onSucesso, onErro}) {
    try {
      const list = (await processaArquivo(url + '/print', state.filtro))
      onSucesso(list)
    } catch (error) {
      console.log('Erro',error)
      onErro()
      nao_autorizado(error)
    }
  },

  async calcMovimentacoes({commit},{filtro,onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/calculo_movimentacoes', filtro)).data
      if (list.length > 0){
        onSucesso(list[0])
      } else {
        onSucesso(list)
      }
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarMovimentoCaixa({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.movimento_caixa, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setMovimentoCaixa({commit}, movimento_caixa) {
    commit('SET_MOVIMENTO_CAIXA', movimento_caixa)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_MOVIMENTO_CAIXAS(state, movimento_caixas) {
    state.all = movimento_caixas
  },
  SET_MOVIMENTO_CAIXA(state, movimento_caixa) {
    state.movimento_caixa = movimento_caixa
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
